<template>
  <span>
    <slot v-if="from && !to" :from="from" name="onlyFirst">
      {{ fromLabel }} {{ formatFunction(from) }} {{ suffix }}
    </slot>
    <slot v-else-if="!from && to" :to="to" name="onlySecond">
      {{ toLabel }} {{ formatFunction(to) }} {{ suffix }}
    </slot>
    <slot v-else-if="from && to" :from="from" :to="to" name="both">
      {{ fromLabel }} {{ formatFunction(from) }} {{ toLabel }}
      {{ formatFunction(to) }}
      {{ suffix }}
    </slot>
    <slot v-else />
  </span>
</template>

<script setup>
import { getDateFormat } from '@/utils/global.js'

const props = defineProps({
  type: {
    type: String,
    default: null,
  },
  suffix: {
    type: String,
    default: '',
  },
  format: {
    type: String,
    default: undefined,
  },
  formatter: {
    type: Function,
    default: null,
  },
  from: {
    type: [String, Date],
    default: null,
  },
  to: {
    type: [String, Date],
    default: null,
  },
  fromLabel: {
    type: String,
    default: 'с',
  },
  toLabel: {
    type: String,
    default: 'до',
  },
})

function formatFunction(val) {
  return props.formatter
    ? props.formatter(val)
    : props.type === 'date'
      ? getDateFormat(val, props.format)
      : val
}
</script>
